import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {Owner} from "../../model/customer/owner";
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearCustomerBackUrl} from "../config/crystalclear-customer-back-url";

@Injectable({
  providedIn: 'root'
})
export class CustomerOwnerService extends CommonCrudService<Owner> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearCustomerBackUrl.GET_CUSTOMER_OWNER_LIST,
      CrystalclearCustomerBackUrl.SAVE_CUSTOMER_OWNER,
      CrystalclearCustomerBackUrl.DELETE_CUSTOMER_OWNER);
  }

}
